var React = require('react');

function Binoculars32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M25 28c-3.857 0-6.996-3.137-6.999-6.994L18 21.003v-4.986l-3.988.02L14 21.003l-.001.003C13.996 24.863 10.857 28 7 28c-3.859 0-7-3.141-7-7 0-.49.053-.968.149-1.43v-.01l4.04-15.929c.001-.007.006-.011.008-.017.001-.006-.001-.012.001-.019A5.03 5.03 0 0 1 9 0c2.757 0 5 2.243 5 5v3.037l4-.029V5.003v-.002V5c0-2.757 2.243-5 5-5a5.025 5.025 0 0 1 4.8 3.597l.001.017c.002.006.007.01.009.017l4.039 15.929v.003c.097.464.151.944.151 1.437 0 3.859-3.141 7-7 7zM2.1 20.008A5.006 5.006 0 0 0 7 26c2.757 0 5-2.243 5-5s-2.243-5-5-5a5.006 5.006 0 0 0-4.886 3.955l-.014.053zm23.776-15.86A3.012 3.012 0 0 0 23 2c-1.654 0-3 1.346-3 3v4a1 1 0 0 1-.992 1l-6 .045H13a1.002 1.002 0 0 1-1-1V5.003v-.002V5c0-1.654-1.346-3-3-3a3.019 3.019 0 0 0-2.88 2.153L3.357 15.052A6.926 6.926 0 0 1 7 14c1.959 0 3.728.814 5 2.117v-.07c0-1.101.895-2.002 1.997-2.01l3.978-.029h.014c.535 0 1.037.207 1.417.584.383.38.594.886.594 1.425v.1A6.969 6.969 0 0 1 25 14c1.338 0 2.577.397 3.641 1.05L25.876 4.148zm4.025 15.871l-.024-.094C29.383 17.684 27.387 16 25 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5c0-.336-.036-.663-.099-.981z","key":1})]);
}

Binoculars32px.displayName = "Binoculars32px";

Binoculars32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 28"};

module.exports = Binoculars32px;

Binoculars32px.default = Binoculars32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/binoculars-32px.svg
// module id = 1089
// module chunks = 0